import React, { useEffect, useState } from 'react';
import styles from './styles';
import { Breadcrumb, Empty, Row, Tag } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { httpCreators, useLoadingSelector } from '@ppvrbh/merchant-frontend-core';
import { REPORT_STATE_KEY, reportStateSelector } from '../redux/report-reducer';
import { REPORT_REQUEST_ID_LIST } from '../redux/report-constant';
import { mainCreators } from '../../../main-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';
import { reportSagas } from '../redux/report-saga';
import { ReportService } from '../redux/report-service';
import { DEFAULT_PAGE_SIZE, MODAL_TYPE } from '../../../../redux/general/general-constant';
import { RBHAlert, RBHBox, RBHButton, RBHTable, RBHText } from '../../../../shared/components';
import metrics from '../../../../shared/theme/metrics';
import styleText from '../../../../shared/components/rbh-text/styles';
import './styles.css';
import styleButton from '../../../../shared/components/rbh-button/styles';
import { AddEditEmailVat } from './addEditEmailVat';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { reportCreators } from '../redux/report-action';
import { AddEditEmailShops } from './addEditEmailShops';
import { MailOutlined } from '@ant-design/icons';

export const ManageEmailScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const emailListVatData = useSelector(reportStateSelector(REPORT_STATE_KEY.EMAIL_LIST_VAT)) as [];
  const emailListShopsData = useSelector(reportStateSelector(REPORT_STATE_KEY.EMAIL_LIST_SHOPS)) as [];
  const loading = useLoadingSelector(REPORT_REQUEST_ID_LIST.GET_CONFIRM_EMAIL);
  const [editVat, setEditVat] = useState(false);
  const [editShops, setEditShops] = useState(false);
  const alertSuccess = useSelector(reportStateSelector(REPORT_STATE_KEY.ALERT_SUCCESS));

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 6));
    dispatch(generalCreators.GetConfig(configSuccess));
  }, []);

  const configSuccess = (manageEmail: string) => {
    if (manageEmail === 'true') {
      resetReload();
    } else {
      toPath('/main/report');
    }
  };

  const toPath = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push(path);
  };

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setEditVat(false);
    setEditShops(false);
    callConfirmEmail();
  };

  const callConfirmEmail = () => {
    dispatch(httpCreators.request({
      id: REPORT_REQUEST_ID_LIST.GET_CONFIRM_EMAIL,
      sagaHandler: reportSagas.getConfirmEmailHandler as any,
      callbackParams: { resetReload },
      service: ReportService.getConfirmEmail,
    }));
  };

  const popupSuccess = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalIcon: <RBHBox id={'mail-icon'} data-testid={'mail-icon'}>
        <MailOutlined translate={null} style={styles.mailIcon} />
      </RBHBox>,
      modalTitle: 'main.report.manageEmail.resend.popup.header',
      modalTitleId: 'resendPopup-header-text',
      modalContent: 'main.report.manageEmail.resend.popup.content',
      modalContentId: 'resendPopup-content-text',
      onOkText: 'main.report.manageEmail.resend.popup.ok',
      onOkTextId: 'resendPopup-ok-text',
      onOk: resetReload,
      type: MODAL_TYPE.ERROR
    }));
  };

  const resendEmail = (value: any, emailType: string) => {
    let data = {};
    if (emailType === 'shopEmailTo') {
      data = {
        email: value.emailTo
      };
    } else if (emailType === 'shopEmailCc' || 'vatEmailCc') {
      data = {
        email: value.emailCc
      };
    }
    dispatch(httpCreators.request({
      id: REPORT_REQUEST_ID_LIST.POST_EMAIL_RESEND,
      sagaHandler: reportSagas.postEmailResendHandler as any,
      callbackParams: { popupSuccess, resetReload },
      service: ReportService.postEmailResend,
      serviceParams: data
    }));
  };

  const addEditEmail = (path?: string, reload?: () => void) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      clickClosable: false,
      escClosable: false,
      onOk: () => {
        if (path) {
          toPath(path);
        } else if (reload) {
          reload();
        }
      },
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  setTimeout(() => {
    if (alertSuccess) {
      dispatch(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_SUCCESS, false));
    }
  }, 3000);

  const handleSuccessClose = () => {
    dispatch(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_SUCCESS, false));
  };

  const isAlert = () => {
    if (alertSuccess) {
      return (
        <RBHBox id={'ManageEmail-alert-success'} data-testid={'ManageEmail-alert-success'}>
          <RBHAlert type={'success'} text={'main.report.manageEmail.alert.success'}
            afterClose={handleSuccessClose} /><br />
        </RBHBox>
      );
    }
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid='breadcrumb-home' id='breadcrumb-home' style={styleText.breadCrumbItemLink}
              onClick={editVat || editShops ? () => addEditEmail('/main') : () => toPath('/main')}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid='breadcrumb-report' id='breadcrumb-report' style={styleText.breadCrumbItemLink}
              onClick={editVat || editShops ? () => addEditEmail('/main/report') : () => toPath('/main/report')}>
              <FormattedMessage id={'main.report'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {editVat || editShops ?
              <a data-testid='breadcrumb-manageEmail' id='breadcrumb-manageEmail' style={styleText.breadCrumbItemLink}
                onClick={() => addEditEmail(undefined, () => resetReload())}>
                <FormattedMessage id={'main.report.manageEmail.breadcrumb.manageEmail'} />
              </a> :
              <span data-testid='breadcrumb-manageEmail' id='breadcrumb-manageEmail' style={styleText.breadCrumbItem}>
                <FormattedMessage id={'main.report.manageEmail.breadcrumb.manageEmail'} />
              </span>
            }
          </Breadcrumb.Item>
          {editVat || editShops ?
            <Breadcrumb.Item>
              <span data-testid={editVat ? 'breadcrumb-addEditEmailVat' : 'breadcrumb-addEditEmailShop'}
                id={editVat ? 'breadcrumb-addEditEmailVat' : 'breadcrumb-addEditEmailShop'} style={styleText.breadCrumbItem}>
                <FormattedMessage id={'main.report.addEditEmailVat.breadcrumb.editEmail'} />
              </span>
            </Breadcrumb.Item> : null
          }
        </Breadcrumb>
      </RBHBox>
    );
  };

  const headerRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText data-testid='manageEmail-header' id='manageEmail-header' style={styleText.headerText}
          text={'main.report.manageEmail.header.manageEmail'} />
      </RBHBox>
    );
  };

  const headerAddEditRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText data-testid={editVat ? 'addEditEmailVat-header' : 'addEditEmailShop-header'} style={styleText.headerText}
          id={editVat ? 'addEditEmailVat-header' : 'addEditEmailShop-header'}
          text={'main.report.addEditEmailVat.header.editEmail'} />
      </RBHBox>
    );
  };

  const vatContentRender = () => {
    return (
      <Row justify={'space-between'} align={'middle'}>
        <RBHBox>
          <RBHText data-testid='vatTable-Header' id='vatTable-Header' style={styles.regular16FakeBlack}
            text={'main.report.manageEmail.table.vat.header'} />
          <RBHText data-testid='vatTable-content1' id='vatTable-content1' style={styles.regular14DarkGray}
            text={'main.report.manageEmail.table.vat.content1'} />
          <RBHText data-testid='vatTable-content2' id='vatTable-content2' style={styles.regular14DarkGray}
            text={'main.report.manageEmail.table.vat.content2'} />
        </RBHBox>
        <RBHBox style={styles.paddingTop30}>
          <RBHButton data-testid={'vat-editEmail-btn'} id={'vat-editEmail-btn'}
            style={styleButton.buttonAdd} text={'main.report.manageEmail.table.vat.editEmail.btn'}
            type='primary' onClick={() => setEditVat(true)} />
        </RBHBox>
      </Row>

    );
  };

  const shopContentRender = () => {
    return (
      <Row justify={'space-between'} align={'middle'}>
        <RBHBox>
          <RBHText data-testid='shopTable-Header' id='shopTable-Header' style={styles.regular16FakeBlack}
            text={'main.report.manageEmail.table.shop.header'} />
          <RBHText data-testid='shopTable-content1' id='shopTable-content1' style={styles.regular14DarkGray}
            text={'main.report.manageEmail.table.shop.content1'} />
          <RBHText data-testid='shopTable-content2' id='shopTable-content2' style={styles.regular14DarkGray}
            text={'main.report.manageEmail.table.shop.content2'} />
        </RBHBox>
        <RBHBox style={styles.paddingTop30}>
          <RBHButton data-testid={'shop-editEmail-btn'} id={'shop-editEmail-btn'}
            style={styleButton.buttonAdd} text={'main.report.manageEmail.table.shop.editEmail.btn'}
            type='primary' onClick={() => { setEditShops(true); }} />
        </RBHBox>
      </Row>
    );
  };

  const tagVatEmailCcRender = (id: string, all: any) => {
    if (all.emailCcVerified === true) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagVerified}>
            <FormattedMessage id={'main.report.manageEmail.table.vat.tag.verified'} />
          </Tag>
        </RBHBox>
      );
    } else if (all.emailCcVerified === false && all.emailCcIsExpired === false) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagPending}>
            <FormattedMessage id={'main.report.manageEmail.table.vat.tag.pending'} />
          </Tag>
        </RBHBox>
      );
    } else if (all.emailCcVerified === false && all.emailCcIsExpired === true) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagExpired}>
            <FormattedMessage id={'main.report.manageEmail.table.vat.tag.expired'} />
          </Tag>
        </RBHBox>
      );
    }
  };

  const tableEmailListVatRender = () => {
    return (
      <RBHBox style={styles.paddingTop20}>
        <RBHTable
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<span> <FormattedMessage id={'main.table.notFound'} /> </span>} />
          }}
          loading={loading}
          rowKey={'emailTo'}
          columns={columnsVat}
          dataSource={emailListVatData}
          pagination={false}>
        </RBHTable>
      </RBHBox>
    );
  };

  const columnsVat = [
    {
      width: metrics.tableHeader.width280,
      title: <FormattedMessage id={'main.report.manageEmail.table.vat.column1'} />,
      render: (value: any, all: any, index: number) => {
        const vatAddress = `vatAddress-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width280 }}>
            <RBHText id={vatAddress} data-testid={vatAddress} style={styleText.textRegularFakeBlack}
              text={'main.report.manageEmail.table.vat.column1.value'} />
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width280,
      title: <FormattedMessage id={'main.report.manageEmail.table.vat.column2'} />,
      render: (value: any, all: any, index: number) => {
        const vatEmailTo = `vatEmailTo-${index}`;
        const vatEmailToLabel = `vatEmailToLabel-${index}`;
        const vatEmailCc = `vatEmailCc-${index}`;
        const vatEmailCcLabel = `vatEmailCcLabel-${index}`;
        const vatPreviousEmailCc = `vatPreviousEmailCc-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width280 }}>
            <RBHBox style={styles.paddingBottom4}>
              <RBHText id={vatEmailToLabel} data-testid={vatEmailToLabel} style={styles.regular12DarkGray}
                text={'main.report.manageEmail.table.vat.email1'} />
              <RBHBox style={styles.width240}>
                <RBHText className={'emailTo-text'} id={vatEmailTo} data-testid={vatEmailTo}
                  style={styles.emailTo}>
                  {all.emailTo}
                </RBHText>
              </RBHBox>
            </RBHBox>
            {all.emailCc ? <br /> : null}
            {all.emailCc ?
              <RBHBox style={styles.paddingBottom4}>
                <RBHText id={vatEmailCcLabel} data-testid={vatEmailCcLabel} style={styles.regular12DarkGray}
                  text={'main.report.manageEmail.table.vat.email2'} />
                <RBHBox style={styles.width240}>
                  <RBHText className={'emailTo-text'} id={vatEmailCc} data-testid={vatEmailCc}
                    style={all.emailCcIsExpired === true && all.emailCcVerified === false ? styles.emailCcIsExpired : styles.emailCc}>
                    {all.emailCc}
                  </RBHText>
                </RBHBox>
              </RBHBox> : null
            }
            {all.emailCc && all.previousEmailCc ?
              <RBHBox style={{ width: '270px', paddingLeft: '63px' }}>
                <RBHText
                  className={all.previousEmailCc.length > 28 ? 'vatPreviousEmailCc-text' : 'previousEmailCc-lowText'}
                  id={vatPreviousEmailCc} data-testid={vatPreviousEmailCc} style={styles.previousEmailCc}
                  text={'main.report.manageEmail.table.vat.column2.value.previousEmailCc'}
                  values={{ email: all.previousEmailCc }} />
              </RBHBox> : null
            }
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width100,
      title: <FormattedMessage id={'main.report.manageEmail.table.vat.column3'} />,
      render: (value: any, all: any, index: number) => {
        const vatEmailToStatus = 'vatEmailToStatus-' + index;
        const vatEmailCcStatus = 'vatEmailCcStatus-' + index;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width100 }}>
            <RBHBox>
              <Tag id={vatEmailToStatus} style={styles.tagVerified}>
                <FormattedMessage id={'main.report.manageEmail.table.vat.tag.verified'} />
              </Tag>
            </RBHBox>
            {all.emailCc ? <br /> : null}
            {tagVatEmailCcRender(vatEmailCcStatus, all)}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width100,
      render: (value: any, all: any, index: number) => {
        if (all.emailCc === undefined) {
          return null;
        }
        const id = `resendConfirmEmailCcVat-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width100, paddingTop: '42px' }}>
            {all.emailCcVerified === false && all.emailCcIsExpired === true ?
              <RBHText data-testid={id} id={id} style={styles.regularPurple12underline}
                text={'main.report.manageEmail.resendEmail'} onClick={() => resendEmail(all, 'vatEmailCc')} /> : null
            }
          </RBHBox>
        );
      }
    }
  ];

  const tableEmailListShopsRender = () => {
    return (
      <RBHBox style={styles.paddingTop20}>
        <RBHTable
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<span> <FormattedMessage id={'main.table.notFound'} /> </span>} />
          }}
          loading={loading}
          rowKey={'shopId'}
          columns={columnsShop}
          dataSource={emailListShopsData}
          onChange={() => { window.scrollTo({ top: 0, behavior: 'auto' }); }}
          pagination={{
            showSizeChanger: false,
            pageSize: DEFAULT_PAGE_SIZE,
            position: ['bottomLeft'],
            hideOnSinglePage: true,
            showTotal: (total: number, range: number[]) => {
              return (
                <RBHText style={styleText.textPaginationShowTotal}>
                  <FormattedMessage id={'main.showing'} />
                  <span data-testid='id-bottom-rage-page'
                    id='id-bottom-rage-page'> {range[0] + '-' + range[1]} </span>
                  <FormattedMessage id={'main.of'} />
                  <span data-testid='id-bottom-total-page' id='id-bottom-total-page'> {total}</span>
                </RBHText>
              );
            }
          }}>
        </RBHTable>
      </RBHBox>
    );
  };

  const tagShopEmailToRender = (id: string, all: any) => {
    if (all.emailToVerified === true) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagVerified}>
            <FormattedMessage id={'main.report.manageEmail.table.shop.tag.verified'} />
          </Tag>
        </RBHBox>
      );
    } else if (all.emailToVerified === false && all.emailToIsExpired === false) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagPending}>
            <FormattedMessage id={'main.report.manageEmail.table.shop.tag.pending'} />
          </Tag>
        </RBHBox>
      );
    } else if (all.emailToVerified === false && all.emailToIsExpired === true) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagExpired}>
            <FormattedMessage id={'main.report.manageEmail.table.shop.tag.expired'} />
          </Tag>
        </RBHBox>
      );
    }
  };

  const tagShopEmailCcRender = (id: string, all: any) => {
    if (all.emailCcVerified === true) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagVerified}>
            <FormattedMessage id={'main.report.manageEmail.table.shop.tag.verified'} />
          </Tag>
        </RBHBox>
      );
    } else if (all.emailCcVerified === false && all.emailCcIsExpired === false) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagPending}>
            <FormattedMessage id={'main.report.manageEmail.table.shop.tag.pending'} />
          </Tag>
        </RBHBox>
      );
    } else if (all.emailCcVerified === false && all.emailCcIsExpired === true) {
      return (
        <RBHBox>
          <Tag id={id} style={styles.tagExpired}>
            <FormattedMessage id={'main.report.manageEmail.table.shop.tag.expired'} />
          </Tag>
        </RBHBox>
      );
    }
  };

  const resendShopEmailToRender = (id: string, all: any) => {
    if (all.emailToVerified === false && all.emailToIsExpired === true) {
      return (
        <RBHText data-testid={id} id={id} style={styles.regularPurple12underline}
          text={'main.report.manageEmail.resendEmail'} onClick={() => resendEmail(all, 'shopEmailTo')} />
      );
    }
  };

  const resendShopEmailCcRender = (id: string, all: any) => {
    if (all.emailCcVerified === false && all.emailCcIsExpired === true) {
      return (
        <RBHText data-testid={id} id={id} style={styles.regularPurple12underline}
          text={'main.report.manageEmail.resendEmail'} onClick={() => resendEmail(all, 'shopEmailCc')} />
      );
    }
  };

  const spaceRender = (value: any) => {
    if (value.previousEmailTo !== undefined && value.previousEmailCc === undefined) {
      if (value.emailToIsExpired && value.emailCcIsExpired) {
        return (
          <RBHBox><br /><br /></RBHBox>
        );
      } else if (value.emailCc === undefined) {
        return null;
      }
      return (
        <RBHBox><br /><br /><br /></RBHBox>
      );
    } else if (value.previousEmailTo !== undefined && value.previousEmailCc !== undefined) {
      if (!value.emailToIsExpired) {
        return (
          <RBHBox><br /><br /><br /></RBHBox>
        );
      }
      return (
        <RBHBox><br /><br /></RBHBox>
      );
    } else if ((value.previousEmailTo === undefined && value.previousEmailCc !== undefined) ||
      (value.previousEmailTo === undefined && value.previousEmailCc === undefined)) {
      return (
        <RBHBox><br /><br /></RBHBox>
      );
    }
  };

  const className = (all: any) => {
    if (all.previousEmailCc.length > 28 && all.previousEmailTo === undefined) {
      return 'shopPreviousEmailCc-long-noEmailTo-text';
    } else if (all.previousEmailCc.length > 28 && all.previousEmailTo !== undefined) {
      return 'shopPreviousEmailCc-long-EmailTo-text';
    } else if (all.previousEmailCc.length < 28 && all.previousEmailTo !== undefined) {
      return 'shopPreviousEmailCc-short-EmailTo-text';
    } else if (all.previousEmailCc.length < 28 && all.previousEmailTo === undefined) {
      return 'shopPreviousEmailCc-short-noEmailTo-text';
    }
  };

  const columnsShop = [
    {
      width: metrics.tableHeader.width300,
      title: <FormattedMessage id={'main.report.manageEmail.table.shop.column1'} />,
      render: (value: any, all: any, index: number) => {
        const shopName = 'shopName-' + index;
        const shopBranchCode = 'branchCode-' + index;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width300 }}>
            <RBHText id={shopName} style={styleText.textRegularFakeBlack}>
              {all.shopName}
            </RBHText>
            <RBHText id={shopBranchCode} style={styles.regular12Gray}>
              {all.branchCode}
            </RBHText>
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width300,
      title: <FormattedMessage id={'main.report.manageEmail.table.shop.column2'} />,
      render: (value: any, all: any, index: number) => {
        const shopEmailTo = `shopEmailTo-${index}`;
        const shopEmailToLabel = `shopEmailToLabel-${index}`;
        const shopEmailCc = `shopEmailCc-${index}`;
        const shopEmailCcLabel = `shopEmailCcLabel-${index}`;
        const shopPreviousEmailTo = `shopPreviousEmailTo-${index}`;
        const shopPreviousEmailCc = `shopPreviousEmailCc-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width300 }}>
            <RBHBox style={styles.paddingBottom4}>
              <RBHText id={shopEmailToLabel} data-testid={shopEmailToLabel} style={styles.regular12DarkGray}
                text={'main.report.manageEmail.table.vat.email1'} />
              <RBHBox style={styles.width240}>
                <RBHText className={'emailTo-text'} id={shopEmailTo} data-testid={shopEmailTo}
                  style={all.emailToIsExpired === true && all.emailToVerified === false ? styles.emailToIsExpired : styles.emailTo}>
                  {all.emailTo}
                </RBHText>
              </RBHBox>
            </RBHBox>
            {all.previousEmailTo ?
              <RBHBox style={{ width: '270px', paddingLeft: '63px' }}>
                <RBHText
                  className={all.previousEmailTo.length > 28 ? 'shopPreviousEmailTo-text' : 'previousEmailCc-lowText'}
                  id={shopPreviousEmailTo} data-testid={shopPreviousEmailTo} style={styles.previousEmailCc}
                  text={'main.report.manageEmail.table.vat.column2.value.previousEmailCc'}
                  values={{ email: all.previousEmailTo }} />
              </RBHBox> : null
            }
            {all.emailCc ? <br /> : null}
            {all.emailCc ?
              <RBHBox style={styles.paddingBottom4}>
                <RBHText id={shopEmailCcLabel} data-testid={shopEmailCcLabel} style={styles.regular12DarkGray}
                  text={'main.report.manageEmail.table.vat.email2'} />
                <RBHBox style={styles.width240}>
                  <RBHText className={'emailTo-text'} id={shopEmailCc} data-testid={shopEmailCc}
                    style={all.emailCcIsExpired === true && all.emailCcVerified === false ? styles.emailCcIsExpired : styles.emailCc}>
                    {all.emailCc}
                  </RBHText>
                </RBHBox>
              </RBHBox> : null
            }
            {all.previousEmailCc ?
              <RBHBox style={{ width: '270px', paddingLeft: '63px' }}>
                <RBHText
                  className={className(all)}
                  id={shopPreviousEmailCc} data-testid={shopPreviousEmailCc} style={styles.previousEmailCc}
                  text={'main.report.manageEmail.table.vat.column2.value.previousEmailCc'}
                  values={{ email: all.previousEmailCc }} />
              </RBHBox> : null
            }
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width100,
      title: <FormattedMessage id={'main.report.manageEmail.table.shop.column3'} />,
      render: (value: any, all: any, index: number) => {
        const shopEmailToStatus = `shopEmailToStatus-${index}`;
        const shopEmailCcStatus = `shopEmailCcStatus-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width100 }}>
            {tagShopEmailToRender(shopEmailToStatus, all)}
            {all.emailCc ? all.previousEmailTo ? <RBHBox><br /><br /></RBHBox> : <RBHBox><br /></RBHBox> : null}
            {tagShopEmailCcRender(shopEmailCcStatus, all)}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width100,
      render: (value: any, all: any, index: number) => {
        const resendConfirmEmailToShop = `resendConfirmEmailToShop-${index}`;
        const resendConfirmEmailCcShop = `resendConfirmEmailCcShop-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width100 }}>
            {resendShopEmailToRender(resendConfirmEmailToShop, all)}
            {spaceRender(all)}
            {resendShopEmailCcRender(resendConfirmEmailCcShop, all)}
          </RBHBox>
        );
      }
    }
  ];

  const remarkRender = () => {
    return (
      <RBHBox>
        <RBHText data-testid='manageEmail-remark' id='manageEmail-remark' style={styles.remarkText}
          text={'main.report.manageEmail.remark'} />
        <RBHText data-testid='manageEmail-remark1' id='manageEmail-remark1' style={styles.remarkText}
          text={'main.report.manageEmail.remark1'} />
        <RBHText data-testid='manageEmail-remark2' id='manageEmail-remark2' style={styles.remarkText}
          text={'main.report.manageEmail.remark2'} />
        <RBHText data-testid='manageEmail-remark3' id='manageEmail-remark3' style={styles.remarkText}
          text={'main.report.manageEmail.remark3'} />
        <RBHText data-testid='manageEmail-remark4' id='manageEmail-remark4' style={styles.remarkText}
          text={'main.report.manageEmail.remark4'} />
      </RBHBox>
    );
  };

  const contentRender = () => {
    if (editShops) {
      return (
        <RBHBox>
          <AddEditEmailShops onSuccessCallBack={resetReload} />
        </RBHBox>
      );
    } else if (editVat) {
      return (
        <RBHBox>
          <AddEditEmailVat onSuccessCallBack={resetReload} />
        </RBHBox>
      );
    } else {
      return (
        <RBHBox>
          <RBHBox style={styles.tablesContent}>
            {vatContentRender()}
            {tableEmailListVatRender()}
          </RBHBox>
          <RBHBox style={styles.tablesContent}>
            {shopContentRender()}
            {tableEmailListShopsRender()}
          </RBHBox>
          {remarkRender()}
        </RBHBox>
      );
    }
  };

  return (
    <RBHBox>
      {isAlert()}
      {BreadcrumbRender()}
      <RBHBox>
        {editVat || editShops ? headerAddEditRender() : headerRender()}
        {loading ? null : contentRender()}
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
